import React from 'react';
import { useTranslation } from 'react-i18next';
import { SIDE_PANEL_CONTENT_TYPE } from 'Common/enums';
import SidePanelAccordionItem from '../SidePanelAccordionItem/SidePanelAccordionItem';

import styles from './SidePanelContent.css';

const SidePanelContent = () => {
    const { t } = useTranslation();
    const accordionItems: string[] = [SIDE_PANEL_CONTENT_TYPE.QUEUE, SIDE_PANEL_CONTENT_TYPE.COMPLETED];
    return (
        <div className={styles.contentContainer}>
            {accordionItems.map((accordionItem, index) => {
                const displayTitle = accordionItem.charAt(0).toUpperCase() + accordionItem.slice(1).toLowerCase();
                const uid = `panelAccordionItem-${accordionItem.toLowerCase()}-${index}`;
                return (
                    <SidePanelAccordionItem
                        key={uid}
                        itemDisplayName={displayTitle}
                        itemTitle={accordionItem.toLowerCase() as SIDE_PANEL_CONTENT_TYPE}
                        noDataMessage={t('No items to show')}
                    />
                );
            })}
        </div>
    );
};

export default SidePanelContent;
